import { alpha, Typography, useMediaQuery } from '@mui/material';
import { FlexBoxColumn } from '../FlexBoxColumn';
import { LyraTheme as theme } from 'src/components/theme/lyra/Theme';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { ResponsiveRow } from '../ResponsiveRow';
import { useLocation } from 'react-router-dom';

interface IErrorProps {
  heading?: string;
  text?: string;
}

export const ErrorFlexBoxColumn = ({ heading, text }: IErrorProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isXLarge = useMediaQuery(theme.breakpoints.up('lg'));
  const location = useLocation();
  const state = location.state as { error?: string } || {};

  const errorHeading = state.error === 'missing_email' ? 'Email Address Required' : heading;
  const errorText1 = state.error === 'missing_email'
      ? 'An email address is required to use the Website Grader tool.'
      : text;
  const errorText2 = state.error === 'missing_email'
      ? 'An error occurred on the page that sent you here with no email address.'
      : "";

  return (
    <FlexBoxColumn
      sx={{
        gap: 2,
        alignSelf: 'stretch',
        background: `linear-gradient(
          0deg,
          ${alpha(theme.palette.primary.light, 0.4)} 0%,
          ${alpha(theme.palette.primary.light, 0.4)} 100%
        ),
        ${theme.palette.common.white}`,
        padding: isMobile ? theme.spacing(3) : isXLarge ? '56px 45px' : '56px 80px',
        borderRadius: '30px',
      }}
    >
      <ResponsiveRow>
        <WarningAmberIcon sx={{ color: 'error.main', height: '36px', width: '36px', pb: isMobile ? 2 : 0 }} />
        <Typography component="div" variant="h3" textAlign={'center'} sx={{ display: 'inline', pl: isMobile ? 0 : 1 }}>
          {errorHeading ?? "Oops, this page doesn't exist."}
        </Typography>
      </ResponsiveRow>
      <Typography component="div" variant="body1" sx={{ fontSize: 18, lineHeight: '24px', textAlign: 'left' }}>
        {errorText1 ?? "The link you followed may be broken, or the page doesn't exist."}
      </Typography>
      {errorText2 && (
        <Typography component="div" variant="body1" sx={{ fontSize: 18, lineHeight: '24px', textAlign: 'left' }}>
          {errorText2}
        </Typography>
      )}
    </FlexBoxColumn>
  );
};
